var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11677",
    "data-name": "Group 11677",
    transform: "translate(-180 -95.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11676",
    "data-name": "Group 11676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11675",
    "data-name": "Group 11675"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "translate(180 95.5)",
    fill: "#e0475b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12998",
    "data-name": "Path 12998",
    d: "M16778.582,1718.045l15,15,31.488-31.489",
    transform: "translate(-16573.645 -1574.085)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.badf8c5f4f5078cfc65aff64aa091cb7.svg";
export { ForwardRef as ReactComponent };